<div class="group row">
  <div class="group column">
    <div class="property">
      <div class="name">ФИО:</div>
      <div class="value">{{testResult.studentName}}</div>
    </div>
    <div class="property">
      <div class="name">Почта:</div>
      <div class="value">{{testResult.studentMail}}</div>
    </div>
    <div class="property">
      <div class="name">IP:</div>
      <div class="value">{{testResult.studentName==='Anonymous' ? 'Anonymous' : testResult.studentIp}}</div>
    </div>
  </div>
  <div class="group column">
    <div *ngIf="testResult.user"
         class="property">
      <div class="name">Пользователь:</div>
      <div class="value">{{testResult.studentName==='Anonymous' ? 'Anonymous' : testResult.user.surname}} {{testResult.studentName==='Anonymous' ? 'Anonymous' :testResult.user.name}} {{testResult.studentName==='Anonymous' ? 'Anonymous' :testResult.user.patronymic}}</div>
    </div>
    <div *ngIf="testResult.link"
         class="property">
      <div class="name">Ссылка:</div>
      <div class="value">{{testResult.link.name}}</div>
    </div>
    <div *ngIf="testResult.link?.trackTelegramUsers"
         class="property">
      <div class="name">Telegram:</div>
      <div class="value">{{testResult.isTelegram ? 'Да' : 'Нет'}}</div>
    </div>
  </div>
  <div class="group column">
    <div *ngIf="testResult.startDate"
         class="property">
      <div class="name">Начат:</div>
      <div class="value">
        <app-time-event [value]="testResult.startDate"></app-time-event>
      </div>
    </div>
    <div *ngIf="testResult.finishDate"
         class="property">
      <div class="name">Завершён:</div>
      <div class="value">
        <app-time-event [value]="testResult.finishDate"></app-time-event>
      </div>
    </div>
    <div *ngIf="testResult.finishDate === null && testResult.expiryDate && !isExpired()"
         class="property">
      <div class="name">Окончание тестирования:</div>
      <div class="value">
        <app-time-event [value]="testResult.expiryDate"></app-time-event>
      </div>
    </div>
    <div *ngIf="testResult.startDate && testResult.finishDate"
         class="property">
      <div class="name">Продолжительность:</div>
      <div class="value">
        <app-time-duration [start]="testResult.startDate"
                           [finish]="testResult.finishDate"
                           [showMs]="false"></app-time-duration>
      </div>
    </div>
  </div>
</div>
<div class="result-row" *ngIf="test && test.type !== 'POLL'">
  <div class="result">
    <div class="score">{{testResult.checkDate === null ? '-' : testResult.points}}/{{testResult.maxPoints}}</div>
    <div class="percent" *ngIf="testResult.checkDate !== null">({{testResult.percent}}%)
    </div>
  </div>
</div>
